import {defineMessages} from 'react-intl';

export default defineMessages({
  addFeedbackTitle: {
    id: 'addDetails',
    defaultMessage: 'Add details'
  },
  addFeedbackSubtitle: {
    id: 'addFeedbackDetailsSubtitle2',
    defaultMessage: 'Further specify your observation if needed'
  },
  typeYourComment: {
    id: 'typeYourComment2',
    defaultMessage: 'Add any comments'
  },
  saveDetails: {
    id: 'saveDetails',
    defaultMessage: 'Save Details'
  },
  unsavedChangesTitle: {
    id: 'unsavedChangesTitle',
    defaultMessage: 'Unsaved changes'
  },
  unsavedChangesSubtitle: {
    id: 'unsavedChangesSubtitle',
    defaultMessage: 'There are unsaved changes. If you close this page, these changes will be discarded.'
  },
  fileStillUploadingTitle: {
    id: 'fileStillUploadingTitle',
    defaultMessage: 'File upload in progress'
  },
  fileStillUploadingSubtitle: {
    id: 'fileStillUploadingSubtitle',
    defaultMessage: 'Your file upload is still in progress. Do you want to save your feedback without the new file?'
  },
  cancel: {
    id: 'cancel',
    defaultMessage: 'Cancel'
  },
  discard: {
    id: 'discard',
    defaultMessage: 'Discard changes'
  },
  saveWithoutNewFile: {
    id: 'saveWithoutNewFile',
    defaultMessage: 'Save without new file'
  },
  uploadNew: {
    id: 'uploadNew',
    defaultMessage: 'Upload new'
  },
  couldNotUploadFileTitle: {
    id: 'couldNotUploadFileTitle',
    defaultMessage: 'Could not upload file'
  },
  couldNotUploadFileSubtitle: {
    id: 'couldNotUploadFileSubtitle',
    defaultMessage: 'The file could not be uploaded because of an error.'
  },
  fileNotSupported: {
    id: 'fileNotSupported',
    defaultMessage: 'The file could not be uploaded because the file format is not supported.'
  },
  tooLarge: {
    id: 'fileTooLarge',
    defaultMessage: 'The file could not be uploaded because it is larger than {allowedSize} MB.'
  },
  tryAgain: {
    id: 'tryAgain',
    defaultMessage: 'Try again'
  },
  delete: {
    id: 'common.actions.delete',
    defaultMessage: 'Delete'
  },
  removeFileSubtitle: {
    id: 'removeFileSubtitle',
    defaultMessage: 'Are you sure you want to delete this file?'
  },
  removeFileTitle: {
    id: 'removeFileTitle',
    defaultMessage: 'Delete file'
  },
  details: {
    id: 'details',
    defaultMessage: 'Details'
  }
});
